__turbopack_context__.v({
  "bottomSheet": "ProductCardBloodVision-module__XzKdlG__bottomSheet",
  "bvMedia": "ProductCardBloodVision-module__XzKdlG__bvMedia",
  "pricing": "ProductCardBloodVision-module__XzKdlG__pricing",
  "root": "ProductCardBloodVision-module__XzKdlG__root",
  "specBlock": "ProductCardBloodVision-module__XzKdlG__specBlock",
});
